import type { HTMLAttributes } from "react";
import { setFallbackImage, type ImageFallbackType } from "./imageFallback";

interface ImageWithFallbackProps extends HTMLAttributes<HTMLImageElement> {
  img: string | null | undefined;
  fallback: ImageFallbackType;
}

export const ImageWithFallback = (props: ImageWithFallbackProps) => {
  const { img, fallback, ...imgProps } = props;
  const src = setFallbackImage({ img, fallback });
  if (src) return <img src={src} {...imgProps} className={props.className} />;
};
